import name from './name'

const selectSliceData = state => state[name]

const selectSkillBites = state => selectSliceData(state).skillBites

export { selectSkillBites }
